"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDesktop = exports.isBackOffice = exports.isWeb = exports.isAndroid = void 0;
const config_1 = require("./config");
var PlatformTypes;
(function (PlatformTypes) {
    PlatformTypes["Android"] = "android";
    PlatformTypes["Ios"] = "ios";
    PlatformTypes["Web"] = "web";
    PlatformTypes["BackOffice"] = "back-office";
})(PlatformTypes || (PlatformTypes = {}));
const isAndroid = () => {
    return config_1.config.platform === PlatformTypes.Android;
};
exports.isAndroid = isAndroid;
const isWeb = () => {
    return config_1.config.platform === PlatformTypes.Web;
};
exports.isWeb = isWeb;
const isBackOffice = () => {
    return config_1.config.platform === PlatformTypes.BackOffice;
};
exports.isBackOffice = isBackOffice;
const isDesktop = () => {
    return (0, exports.isWeb)() || (0, exports.isBackOffice)();
};
exports.isDesktop = isDesktop;
